export const cascaderCarType = [
  {
    value: '9', label: '客车', children: [
      { value: '1', label: '一型客车', },
      { value: '2', label: '二型客车', },
      { value: '3', label: '三型客车', },
      { value: '4', label: '四型客车', },
    ]
  },
  {
    value: '19', label: '货车', children: [
      { value: '11', label: '一型货车', },
      { value: '12', label: '二型货车', },
      { value: '13', label: '三型货车', },
      { value: '14', label: '四型货车', },
      { value: '15', label: '五型货车', },
      { value: '16', label: '六型货车', },
    ]
  },
  {
    value: '29', label: '专项作业车', children: [
      { value: '21', label: '一型专项作业车', },
      { value: '22', label: '二型专项作业车', },
      { value: '23', label: '三型专项作业车', },
      { value: '24', label: '四型专项作业车', },
      { value: '25', label: '五型专项作业车', },
      { value: '26', label: '六型专项作业车', },
    ]
  },
  { value: '0', label: '未知', }
];

export const dataType = ['busOne', 'busTwo', 'busThree', 'busFour',
  'truckOne', 'truckTwo', 'truckThree', 'truckFour', 'truckFive', 'truckSix',
  'specialOne', 'specialTwo', 'specialThree', 'specialFour', 'specialFive', 'specialSix'
];
export const tableType = ['car1', 'car2', 'car3', 'car4',
  'truck1', 'truck2', 'truck3', 'truck4', 'truck5', 'truck6',
  'special1', 'special2', 'special3', 'special4', 'special5', 'special6'];
export const inoutType = [
  { label: '出', value: '出' },
  { label: '入', value: '入' },
  { label: '上行', value: '上行' },
  { label: '下行', value: '下行' }
];
export const auditType = [
  { value: 0, label: '待确认' },
  { value: 1, label: '确认属实' },
  { value: -1, label: '确认失实' },
];
export const queryType = [
  { value: 'all', label: '全部流水' },
  { value: 'normal', label: '正常行驶' },
  { value: 'waitAnalysis', label: '待分析' },
  { value: 'dataLose', label: '计费缺失' },
  { value: 'vehicleTypeDifferent', label: '车型不一致' },
  // { value: 'specialClass', label: '危化品车辆' },
];
// 车辆类型字典
export const carType = [{
  "dictId": "dict_identifyType_K1",
  "dictionariesName": "一型客车",
  "dictionariesValue": "1",
}, {
  "dictId": "dict_identifyType_K2",
  "dictionariesName": "二型客车",
  "dictionariesValue": "2",
}, {
  "dictId": "dict_identifyType_K3",
  "dictionariesName": "三型客车",
  "dictionariesValue": "3",
}, {
  "dictId": "dict_identifyType_K4",
  "dictionariesName": "四型客车",
  "dictionariesValue": "4",
}, {
  "dictId": "dict_identifyType_H1",
  "dictionariesName": "一型货车",
  "dictionariesValue": "11",
}, {
  "dictId": "dict_identifyType_H2",
  "dictionariesName": "二型货车",
  "dictionariesValue": "12",
}, {
  "dictId": "dict_identifyType_H3",
  "dictionariesName": "三型货车",
  "dictionariesValue": "13",
}, {
  "dictId": "dict_identifyType_H4",
  "dictionariesName": "四型货车",
  "dictionariesValue": "14",
}, {
  "dictId": "dict_identifyType_H5",
  "dictionariesName": "五型货车",
  "dictionariesValue": "15",
}, {
  "dictId": "dict_identifyType_H6",
  "dictionariesName": "六型货车",
  "dictionariesValue": "16",
}, {
  "dictId": "dict_identifyType_Unknow",
  "dictionariesName": "未知",
  "dictionariesValue": "0",
}, {
  "dictId": "dict_identifyType_S1",
  "dictionariesName": "一型专项作业车",
  "dictionariesValue": "21",
}, {
  "dictId": "dict_identifyType_S2",
  "dictionariesName": "二型专项作业车",
  "dictionariesValue": "22",
}, {
  "dictId": "dict_identifyType_S3",
  "dictionariesName": "三型专项作业车",
  "dictionariesValue": "23",
}, {
  "dictId": "dict_identifyType_S4",
  "dictionariesName": "四型专项作业车",
  "dictionariesValue": "24",
}, {
  "dictId": "dict_identifyType_S5",
  "dictionariesName": "五型专项作业车",
  "dictionariesValue": "25",
}, {
  "dictId": "dict_identifyType_S6",
  "dictionariesName": "六型专项作业车",
  "dictionariesValue": "26",
}];
